<template>
  <v-container fluid>
      <a-page-header :title="title" icon="flaticon-user"/>   

      <v-divider/> 

      <v-row>
        <v-col sm="12">
          <v-tabs v-model="tab">
          <v-tab href="#tab-1">        
            CONSTRUCTEURS
          </v-tab>
          <v-tab href="#tab-2">         
            GARAGES
          </v-tab>
           <v-tab href="#tab-3">         
            LOUEURS
          </v-tab>
          <v-tab href="#tab-4">      
            PETROLIERS
          </v-tab>
          
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <a-provider-list     
                  provider-type="4"              
                  single-select             
                  @clickRow="onClickRowProvider"          
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text>
                <a-provider-list     
                  provider-type="2"              
                  single-select             
                  @clickRow="onClickRowProvider"       
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-card flat>
              <v-card-text>
                <a-provider-list     
                  provider-type="3"              
                  single-select             
                  @clickRow="onClickRowProvider"       
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-4">
            <v-card flat>
              <v-card-text>
                <a-provider-list     
                  provider-type="1"
                  only-import
                  single-select             
                  @clickRow="onClickRowProvider"       
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        </v-col>
      </v-row>
  </v-container>  
</template>

<script>

import APageHeader from "@/components/APageHeader"
import AProviderList from "@/components/AProviderList"

import { mapGetters } from 'vuex'

export default {
  name: 'Settings',
  components: { APageHeader, AProviderList },
  data: () => ({
    title: "Paramètres"
  }),
  methods: {
    onClickRowProvider: function(row) {
      this.$router.push({ 
        name: 'Provider', 
        params: { 
          id: row.id
        }
      })
    }
  },
  mounted() {
    
  },
  computed: {
    ...mapGetters([
      'userEnvironment',
      'settingsTab'
    ]),
    tab: {
      get() {
        return this.settingsTab
      },
      set(value) {
        this.$store.commit('setSettingsTab', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
